/* Magnellove · Shopify-Theme
   1. Grundlagen: Texte, Geldformat, Menü, Handy-Leiste, Anschnapp-Bewegung beim Scrollen, Sprachhinweis
   2. Gestalter (Produktseite): Fotos laden, Ausschnitt wählen, Variante (Anzahl × Format × weitere Optionen) bestimmen und das
      Produktformular mit den zugeschnittenen Fotos als Dateien absenden (properties[Foto n], multipart).
   3. Live-Vorschau „Para festas“ / „Para negócios“ (Shopify-Kontaktformular)
   4. Betriebs-Magnet zum Ausprobieren (Startseite, Abschnitt mg-beweis)
   Herkunft: src/static/js/{shop,casa,vorschau,beweis}.js des geprüften Prototyps. */
(function () {
  'use strict';

  // ---------- 1. Grundlagen ----------
  var quelle = document.getElementById('ml-daten');
  var D = quelle ? JSON.parse(quelle.textContent) : { ui: {}, locale: 'pt-PT', waehrung: 'EUR' };
  var bewegungAus = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var format;
  try { format = new Intl.NumberFormat(D.locale, { style: 'currency', currency: D.waehrung || 'EUR' }); }
  catch (e) { format = new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }); }
  function geld(cent) { return format.format(cent / 100); }
  function t(schluessel, werte) {
    var text = (D.ui && D.ui[schluessel]) || schluessel;
    if (werte) Object.keys(werte).forEach(function (k) { text = text.split('{' + k + '}').join(String(werte[k])); });
    return text;
  }
  function schnapp(el) {
    if (!el || bewegungAus) return;
    el.classList.remove('schnappt'); void el.offsetWidth; el.classList.add('schnappt');
  }

  var menue = document.querySelector('[data-menue]');
  var nav = document.getElementById('hauptnav');
  if (menue && nav) {
    menue.hidden = false;
    menue.setAttribute('aria-label', t('menu_auf'));
    menue.addEventListener('click', function () {
      var offen = nav.classList.toggle('offen');
      menue.setAttribute('aria-expanded', offen ? 'true' : 'false');
      menue.setAttribute('aria-label', t(offen ? 'menu_zu' : 'menu_auf'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('offen')) {
        nav.classList.remove('offen'); menue.setAttribute('aria-expanded', 'false'); menue.focus();
      }
    });
  }

  // Handy-Leiste: erscheint, wenn der erste Abschnitt vorbei ist, und weicht dem Schluss und dem Fuß.
  // Shopify legt um jeden Abschnitt eine Hülle (div.shopify-section), daher „main section“ statt „main > section“.
  var leiste = document.querySelector('[data-leiste]');
  if (leiste && 'IntersectionObserver' in window) {
    var start = document.querySelector('main section');
    var ende = document.querySelectorAll('.schluss, .fuss');
    var startSichtbar = true, sichtbar = [];
    var setze = function () { leiste.classList.toggle('an', !startSichtbar && sichtbar.length === 0); };
    if (start) new IntersectionObserver(function (e) { startSichtbar = e[0].isIntersecting; setze(); }, { threshold: 0.15 }).observe(start);
    var beob = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        var i = sichtbar.indexOf(x.target);
        if (x.isIntersecting && i < 0) sichtbar.push(x.target);
        if (!x.isIntersecting && i > -1) sichtbar.splice(i, 1);
      });
      setze();
    });
    ende.forEach(function (el) { beob.observe(el); });
  }

  // Anschnappen beim Scrollen: Abschnittsköpfe, Kacheln, Sets, Schritte, Bilder. Gruppen kommen nacheinander.
  // Sicherheitsnetz: Nach 2,5 s ist alles sichtbar, auch wenn der Beobachter nie meldet (Druck, Bildschirmfotos).
  if (!bewegungAus && 'IntersectionObserver' in window) {
    var ziele = document.querySelectorAll('.kopfzeile, .kachel, .setkarte, .bildschritte li, .beweis__seite, .handwerk__bild, .seitenkopf__bild, .fragen details, .schluss__text, .wand__magnet, .start__vorteile li');
    if (ziele.length) {
      document.documentElement.classList.add('zeigen-an');
      ziele.forEach(function (el) {
        el.setAttribute('data-zeigen', '');
        var geschwister = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.setProperty('--v', Math.min(geschwister, 5) * 80 + 'ms');
      });
      var zeigen = new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('gezeigt'); zeigen.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      ziele.forEach(function (el) { zeigen.observe(el); });
      setTimeout(function () { ziele.forEach(function (el) { el.classList.add('gezeigt'); }); }, 2500);
    }
  }

  // Sprachwahl: einmal beim ersten Besuch auf die andere Sprache aufmerksam machen (schnappt an, Sprechblase 4 s)
  var sprachknopf = document.querySelector('[data-sprachknopf]');
  var sprachhinweis = document.querySelector('[data-sprachhinweis]');
  if (sprachknopf && sprachhinweis) {
    var schonGesehen = false;
    try { schonGesehen = window.localStorage.getItem('magnellove.sprachhinweis') === '1'; } catch (e) { schonGesehen = true; }
    if (!schonGesehen) {
      setTimeout(function () {
        sprachhinweis.hidden = false; sprachhinweis.classList.add('zeigt');
        if (!bewegungAus) sprachknopf.classList.add('lockt');
        try { window.localStorage.setItem('magnellove.sprachhinweis', '1'); } catch (e) {}
        setTimeout(function () { sprachhinweis.hidden = true; }, 4000);
      }, 1400);
    }
  }

  // Cookie-Einstellungen erneut öffnen (Shopify-Cookie-Hinweis, window.privacyBanner); ohne Hinweis bleibt der Knopf verborgen
  var cookieKnopf = document.querySelector('[data-cookie-einstellungen]');
  if (cookieKnopf) {
    var cookiePruefen = function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { cookieKnopf.hidden = false; return true; }
      return false;
    };
    if (!cookiePruefen()) window.addEventListener('load', function () { setTimeout(cookiePruefen, 1500); });
    cookieKnopf.addEventListener('click', function () { if (window.privacyBanner) window.privacyBanner.showPreferences(); });
  }

  // ---------- 2. Gestalter (Produktseite) ----------
  // Varianten = Anzahl × Format (× weitere Optionen wie „Schriftzug“). Das Format („78 × 53 mm“) bestimmt das Seitenverhältnis
  // jedes Ausschnitts; rechteckige Formate gibt es quer und hoch. Ab mehr als 10 Magneten reichen weniger Fotos (gleichmäßig verteilt).
  // Farben und eigener Schriftzug ändern den Preis nicht und gehen als Zusatzangaben an die Bestellung.
  (function () {
    var wurzel = document.querySelector('[data-gestalter="casa"]');
    if (!wurzel) return;
    var VARIANTEN = JSON.parse(wurzel.querySelector('[data-varianten]').textContent);
    var MIN_PX = D.min_px || 600, MAX_MB = D.max_mb || 25, DRUCK_PX = 1600, VIELE = 10;
    var form = wurzel.querySelector('[data-produkt-form]');
    var feldVariante = form.querySelector('[data-variante]');
    var feldRecorte = form.querySelector('[data-recorte]');
    var dateiAblage = form.querySelector('[data-datei-ablage]');
    var liste = wurzel.querySelector('[data-slots]');
    var alle = wurzel.querySelector('[data-alle]');
    var ablage = wurzel.querySelector('[data-ablage]');
    var mini = wurzel.querySelector('[data-mini]');
    var knopf = wurzel.querySelector('[data-in-korb]');
    var status = wurzel.querySelector('[data-status]');
    var vieleHinweis = wurzel.querySelector('[data-viele-hinweis]');
    var ausrichtungBox = wurzel.querySelector('[data-ausrichtung]');
    var preisOben = wurzel.querySelector('[data-preis-oben]');
    var vieleText = vieleHinweis.textContent;
    var aus = { set: wurzel.querySelector('[data-r-set]'), format: wurzel.querySelector('[data-r-format]'), summe: wurzel.querySelector('[data-r-total]'),
      auswahl: wurzel.querySelector('[data-r-auswahl]'), auswahlZeile: wurzel.querySelector('[data-r-auswahl-zeile]') };
    var I_ANZAHL = +wurzel.getAttribute('data-i-anzahl'), I_FORMAT = +wurzel.getAttribute('data-i-format');
    var FORMAT_STD = wurzel.getAttribute('data-format-std') || '';
    var OPTIONEN = VARIANTEN.length ? VARIANTEN[0].werte.length : 0;
    var freitexte = wurzel.querySelectorAll('[data-freitext]');
    // Leerer Rahmen dazu: eigenes Zubehör-Produkt, wird vor dem Set in den Warenkorb gelegt
    var zub = wurzel.querySelector('[data-zubehoer]'), zubAn = zub && zub.querySelector('[data-zubehoer-an]');
    var zubFarbe = zub && zub.querySelector('[data-zubehoer-farbe]'), zubSelect = zubFarbe && zubFarbe.querySelector('select');
    function mitRahmen() { return !!zubAn && zubAn.checked; }
    var kundenart = wurzel.querySelector('[data-kundenart]'), firmaBox = wurzel.querySelector('[data-firma]');
    var firmaFeld = firmaBox && firmaBox.querySelector('[data-firma-feld]');
    // Firmenname nur, wenn ab 50 Magneten „Firma“ gewählt ist
    function alsFirma() { return !!kundenart && anzahl() >= 50 && wert('mg_kunde') === 'firma'; }

    var MAX = Math.max.apply(null, VARIANTEN.map(function (v) { return I_ANZAHL >= 0 ? (parseInt(v.werte[I_ANZAHL], 10) || 1) : 1; }));
    var plaetze = [];
    for (var i = 0; i < MAX; i++) plaetze.push(leer());
    function leer() { return { bild: null, url: null, w: 0, h: 0, zoom: 1, cx: 0.5, cy: 0.5, fehler: '', name: '' }; }

    // Auswahl als Menü (select) oder als Radio-Knöpfe
    function wert(name) {
      var m = wurzel.querySelector('select[name="' + name + '"]');
      if (m) return m.value;
      var r = wurzel.querySelector('input[name="' + name + '"]:checked'); return r ? r.value : '';
    }
    function menuepunkt(name) { var m = wurzel.querySelector('select[name="' + name + '"]'); return m ? m.options[m.selectedIndex] : null; }
    function anzahl() { return parseInt(wert('mg_anzahl'), 10) || 1; }
    function formatWert() { return wert('mg_format') || FORMAT_STD; }
    function masseVon(fmt) { var m = /(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/.exec(fmt || ''); return m ? [parseFloat(m[1]), parseFloat(m[2])] : [1, 1]; }
    function quadratisch() { var m = masseVon(formatWert()); return m[0] === m[1]; }
    function ausrichtung() { return quadratisch() ? '' : (wert('mg_ausrichtung') || 'quer'); }
    // Seitenverhältnis Breite : Höhe des Ausschnitts
    function verhaeltnis() {
      var m = masseVon(formatWert()), a = Math.max(m[0], m[1]) / Math.min(m[0], m[1]);
      if (m[0] === m[1]) return 1;
      return ausrichtung() === 'hoch' ? 1 / a : a;
    }
    function viele() { return anzahl() > VIELE; }
    // Gewählte Optionswerte in der Reihenfolge der Produktoptionen; „aendern“ ersetzt einzelne Stellen ({index: wert})
    function auswahl(aendern) {
      var w = [];
      for (var i = 0; i < OPTIONEN; i++) {
        if (aendern && i in aendern) w.push(String(aendern[i]));
        else if (i === I_ANZAHL) w.push(wert('mg_anzahl'));
        else if (i === I_FORMAT) w.push(wert('mg_format'));
        else w.push(wert('mg_opt_' + i));
      }
      return w;
    }
    function variante(w) {
      for (var i = 0; i < VARIANTEN.length; i++) if (VARIANTEN[i].werte.join('\u0001') === w.join('\u0001')) return VARIANTEN[i];
      return null;
    }
    // Eigener Schriftzug: Feld zeigen, wenn der passende Wert gewählt ist
    function freitextAktiv(box) { return wert('mg_opt_' + box.closest('[data-option]').getAttribute('data-option')) === box.getAttribute('data-freitext-wert'); }
    function freitextFehlt() {
      return Array.prototype.some.call(freitexte, function (box) { return freitextAktiv(box) && !box.querySelector('[data-freitext-feld]').value.trim(); });
    }
    // Schriftfarbe nur, wenn ein Schriftzug gewählt ist
    function mitSchriftzug() {
      return !Array.prototype.some.call(wurzel.querySelectorAll('[data-option] select'), function (m) { return m.options[m.selectedIndex].hasAttribute('data-ohne'); });
    }
    function farbfelder() {
      return Array.prototype.filter.call(wurzel.querySelectorAll('[data-farbfeld]'), function (f) { return !f.hidden; });
    }

    function istHeic(d) { return /\.(heic|heif)$/i.test(d.name) || /heic|heif/i.test(d.type); }
    function laden(datei, index, fertig) {
      var platz = plaetze[index];
      if (!datei.type.match(/^image\//) && !istHeic(datei)) { platz.fehler = t('kein_bild'); return fertig(); }
      if (datei.size > MAX_MB * 1024 * 1024) { platz.fehler = t('zu_gross', { mb: MAX_MB }); return fertig(); }
      var url = URL.createObjectURL(datei);
      var bild = new Image();
      bild.decoding = 'async';
      bild.onload = function () {
        freigeben(platz);
        plaetze[index] = { bild: bild, url: url, w: bild.naturalWidth, h: bild.naturalHeight, zoom: 1, cx: 0.5, cy: 0.5, fehler: '', name: datei.name };
        fertig();
      };
      bild.onerror = function () { URL.revokeObjectURL(url); platz.fehler = istHeic(datei) ? t('heic') : t('kaputt'); fertig(); };
      bild.src = url;
    }
    function freigeben(platz) {
      if (platz.url && !plaetze.some(function (p) { return p !== platz && p.url === platz.url; })) URL.revokeObjectURL(platz.url);
    }
    function verteilen(dateien) {
      dateien = Array.prototype.slice.call(dateien || []);
      if (!dateien.length) return;
      var n = anzahl(), freie = [];
      for (var i = 0; i < n; i++) if (!plaetze[i].bild) freie.push(i);
      if (!freie.length) return melde(t('alle_voll'), 'fehler');
      var zuViele = dateien.length > freie.length, offen = Math.min(dateien.length, freie.length);
      dateien.slice(0, offen).forEach(function (d, k) {
        laden(d, freie[k], function () { if (--offen === 0) { zeichnen(); zeigeVorschau(); if (zuViele) melde(t('zu_viele', { n: freie.length }), ''); } });
      });
    }
    alle.addEventListener('change', function () { verteilen(alle.files); alle.value = ''; });
    ['dragenter', 'dragover'].forEach(function (a) { ablage.addEventListener(a, function (e) { e.preventDefault(); ablage.classList.add('ueber'); }); });
    ['dragleave', 'drop'].forEach(function (a) { ablage.addEventListener(a, function (e) { e.preventDefault(); ablage.classList.remove('ueber'); }); });
    ablage.addEventListener('drop', function (e) { if (e.dataTransfer) verteilen(e.dataTransfer.files); });

    // Ausschnitt im Foto (Pixel): so groß wie möglich im Seitenverhältnis A, geteilt durch den Zoom
    function ausschnitt(platz) {
      var A = verhaeltnis();
      if (platz.w / platz.h > A) return { cw: A * platz.h / platz.zoom, ch: platz.h / platz.zoom };
      return { cw: platz.w / platz.zoom, ch: platz.w / A / platz.zoom };
    }
    function begrenzen(platz) {
      var a = ausschnitt(platz), hx = a.cw / 2 / platz.w, hy = a.ch / 2 / platz.h;
      platz.cx = Math.min(1 - hx, Math.max(hx, platz.cx));
      platz.cy = Math.min(1 - hy, Math.max(hy, platz.cy));
    }
    function setzen(platz, rahmen) {
      var img = rahmen.querySelector('img');
      if (!img) return;
      begrenzen(platz);
      var a = ausschnitt(platz), Fw = rahmen.clientWidth || 160, Fh = rahmen.clientHeight || Fw, s = Fw / a.cw;
      img.style.width = (platz.w * s) + 'px';
      img.style.height = (platz.h * s) + 'px';
      img.style.transform = 'translate(' + (Fw / 2 - platz.cx * platz.w * s).toFixed(1) + 'px,' + (Fh / 2 - platz.cy * platz.h * s).toFixed(1) + 'px)';
    }
    function zuWenigPixel(platz) { var a = ausschnitt(platz); return Math.min(a.cw, a.ch) < MIN_PX; }

    function bedienung(platz, rahmen, regler, warnung) {
      var zeiger = {}, start = null;
      function zoomAuf(z) { platz.zoom = Math.min(4, Math.max(1, z)); regler.value = platz.zoom; setzen(platz, rahmen); warnung.hidden = !zuWenigPixel(platz); }
      rahmen.addEventListener('pointerdown', function (e) {
        rahmen.setPointerCapture(e.pointerId);
        zeiger[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(zeiger);
        if (ids.length === 2) { var a = zeiger[ids[0]], b = zeiger[ids[1]]; start = { abstand: Math.hypot(a.x - b.x, a.y - b.y), zoom: platz.zoom }; }
      });
      rahmen.addEventListener('pointermove', function (e) {
        if (!zeiger[e.pointerId]) return;
        var vorher = zeiger[e.pointerId];
        zeiger[e.pointerId] = { x: e.clientX, y: e.clientY };
        var ids = Object.keys(zeiger);
        if (ids.length === 2 && start) { var a = zeiger[ids[0]], b = zeiger[ids[1]]; zoomAuf(start.zoom * Math.hypot(a.x - b.x, a.y - b.y) / start.abstand); return; }
        var s = (rahmen.clientWidth || 160) / ausschnitt(platz).cw;
        platz.cx -= (e.clientX - vorher.x) / (platz.w * s);
        platz.cy -= (e.clientY - vorher.y) / (platz.h * s);
        setzen(platz, rahmen);
      });
      function los(e) { delete zeiger[e.pointerId]; if (Object.keys(zeiger).length < 2) start = null; aktualisieren(); }
      rahmen.addEventListener('pointerup', los);
      rahmen.addEventListener('pointercancel', los);
      rahmen.addEventListener('wheel', function (e) { if (!e.ctrlKey) return; e.preventDefault(); zoomAuf(platz.zoom * (e.deltaY < 0 ? 1.06 : 0.94)); }, { passive: false });
      rahmen.addEventListener('keydown', function (e) {
        var schritt = 0.04 / platz.zoom;
        if (e.key === 'ArrowLeft') platz.cx -= schritt;
        else if (e.key === 'ArrowRight') platz.cx += schritt;
        else if (e.key === 'ArrowUp') platz.cy -= schritt;
        else if (e.key === 'ArrowDown') platz.cy += schritt;
        else if (e.key === '+' || e.key === '=') return zoomAuf(platz.zoom + 0.1);
        else if (e.key === '-' || e.key === '−') return zoomAuf(platz.zoom - 0.1);
        else return;
        e.preventDefault();
        setzen(platz, rahmen);
      });
      regler.addEventListener('input', function () { zoomAuf(parseFloat(regler.value)); });
      regler.addEventListener('change', aktualisieren);
    }

    function knopfEl(text, aktion) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'link-knopf'; b.textContent = text;
      b.addEventListener('click', aktion);
      return b;
    }
    // Bei vielen Magneten rücken die Fotos zusammen; gezeigt werden alle Fotos und ein freier Platz.
    function zusammenruecken() {
      var voll = plaetze.filter(function (p) { return p.bild; });
      for (var i = 0; i < plaetze.length; i++) plaetze[i] = voll[i] || leer();
    }
    function zeichnen() {
      var n = anzahl(), sichtbar = n;
      wurzel.style.setProperty('--seite', verhaeltnis());
      if (viele()) {
        zusammenruecken();
        var gefuellt = 0;
        for (var k = 0; k < n; k++) if (plaetze[k].bild) gefuellt++;
        sichtbar = Math.min(n, gefuellt + 1);
      }
      vieleHinweis.hidden = !viele();
      vieleHinweis.textContent = vieleText.split('{n}').join(String(n));
      if (ausrichtungBox) ausrichtungBox.hidden = quadratisch();
      liste.textContent = '';
      for (var i = 0; i < sichtbar; i++) liste.appendChild(platzEl(i, n));
      aktualisieren();
    }
    function platzEl(i, n) {
      var platz = plaetze[i];
      var li = document.createElement('li');
      li.className = 'slot';
      var nr = document.createElement('span');
      nr.className = 'slot__nr';
      nr.textContent = t('slot_nr', { n: i + 1 });
      li.appendChild(nr);
      var feld = document.createElement('input');
      feld.type = 'file'; feld.accept = 'image/*,.heic,.heif'; feld.className = 'datei-feld'; feld.id = 'foto-' + i;
      feld.addEventListener('change', function () { if (feld.files && feld.files[0]) laden(feld.files[0], i, function () { zeichnen(); zeigeVorschau(); }); });
      if (!platz.bild) {
        li.appendChild(feld);
        var label = document.createElement('label');
        label.className = 'rahmen rahmen--leer'; label.htmlFor = feld.id;
        var plus = document.createElement('span');
        plus.className = 'rahmen__plus'; plus.textContent = t('foto_waehlen');
        label.appendChild(plus);
        li.appendChild(label);
      } else {
        var rahmen = document.createElement('div');
        rahmen.className = 'rahmen'; rahmen.tabIndex = 0; rahmen.dataset.i = i;
        rahmen.setAttribute('role', 'group');
        rahmen.setAttribute('aria-label', t('slot_nr', { n: i + 1 }) + '. ' + t('frame_hilfe'));
        var img = document.createElement('img');
        img.src = platz.url; img.alt = ''; img.draggable = false; img.width = platz.w; img.height = platz.h;
        rahmen.appendChild(img);
        li.appendChild(rahmen);
        var zoom = document.createElement('label');
        zoom.className = 'slot__zoom'; zoom.textContent = t('zoom');
        var regler = document.createElement('input');
        regler.type = 'range'; regler.min = '1'; regler.max = '4'; regler.step = '0.01'; regler.value = platz.zoom;
        zoom.appendChild(regler);
        li.appendChild(zoom);
        var warnung = document.createElement('p');
        warnung.className = 'slot__warnung'; warnung.textContent = t('unscharf'); warnung.hidden = !zuWenigPixel(platz);
        li.appendChild(warnung);
        li.appendChild(feld);
        var aktionen = document.createElement('div');
        aktionen.className = 'slot__aktionen';
        var tauschen = document.createElement('label');
        tauschen.className = 'link-knopf'; tauschen.htmlFor = feld.id; tauschen.textContent = t('foto_tauschen');
        aktionen.appendChild(tauschen);
        var naechster = -1;
        if (!viele()) for (var k = 0; k < n; k++) if (!plaetze[k].bild) { naechster = k; break; }
        if (naechster >= 0) {
          aktionen.appendChild(knopfEl(t('foto_wiederholen'), function () {
            plaetze[naechster] = { bild: platz.bild, url: platz.url, w: platz.w, h: platz.h, zoom: 1, cx: 0.5, cy: 0.5, fehler: '', name: platz.name };
            zeichnen();
          }));
        }
        aktionen.appendChild(knopfEl(t('foto_weg'), function () { freigeben(platz); plaetze[i] = leer(); zeichnen(); }));
        li.appendChild(aktionen);
        bedienung(platz, rahmen, regler, warnung);
        requestAnimationFrame(function () { setzen(platz, rahmen); });
      }
      if (platz.fehler) {
        var f = document.createElement('p');
        f.className = 'slot__fehler'; f.setAttribute('role', 'alert'); f.textContent = platz.fehler;
        li.appendChild(f);
        platz.fehler = '';
      }
      return li;
    }

    // Preise je Menge für das gewählte Format, mit Ersparnis je Magnet gegenüber dem kleinsten Set
    function preiseZeigen() {
      var basis = null;
      if (I_ANZAHL >= 0) wurzel.querySelectorAll('input[name="mg_anzahl"]').forEach(function (r) {
        var o = {}; o[I_ANZAHL] = r.value;
        var v = variante(auswahl(o));
        if (v && (!basis || +r.value < +basis.n)) basis = { n: r.value, preis: v.preis };
      });
      wurzel.querySelectorAll('input[name="mg_anzahl"]').forEach(function (r) {
        var o = {}; o[I_ANZAHL] = r.value;
        var zeile = r.closest('.menge'), v = variante(auswahl(o));
        if (!zeile) return;
        zeile.hidden = !v;
        if (!v) return;
        var stueck = v.preis / +r.value;
        zeile.querySelector('[data-mpreis]').textContent = geld(v.preis);
        zeile.querySelector('[data-mstueck]').textContent = t('je_magnet', { preis: geld(Math.round(stueck)) });
        var spar = basis ? Math.round((1 - stueck / (basis.preis / +basis.n)) * 100) : 0;
        var marke = zeile.querySelector('[data-spar]');
        marke.textContent = spar >= 5 ? t('spar', { p: spar }) : '';
        marke.hidden = spar < 5;
      });
      // Weitere Optionen: Aufpreis gegenüber dem günstigsten Wert zeigen, fehlende Kombinationen ausblenden
      wurzel.querySelectorAll('[data-option]').forEach(function (feld) {
        var i = +feld.getAttribute('data-option'), preise = [];
        var eintraege = feld.querySelectorAll('select option');
        eintraege.forEach(function (r) {
          var o = {}; o[i] = r.value;
          var v = variante(auswahl(o));
          preise.push(v ? v.preis : null);
        });
        var min = Math.min.apply(null, preise.filter(function (x) { return x !== null; }));
        // Kosten alle teureren Werte gleich viel mehr, steht der Aufpreis einmal neben der Überschrift
        var aufpreise = preise.filter(function (x) { return x !== null && x > min; }).map(function (x) { return x - min; });
        var einheitlich = aufpreise.length > 1 && aufpreise.every(function (x) { return x === aufpreise[0]; });
        feld.querySelector('[data-aufpreis-legende]').textContent = einheitlich ? t('aufpreis_ab', { preis: geld(aufpreise[0]) }) : '';
        eintraege.forEach(function (r, k) {
          r.hidden = r.disabled = preise[k] === null;
          r.textContent = r.getAttribute('data-text') + (!einheitlich && preise[k] !== null && preise[k] > min ? ' (+' + geld(preise[k] - min) + ')' : '');
        });
      });
    }

    var vorschauAn = false;
    function zeigeVorschau() { if (!vorschauAn && plaetze.some(function (p) { return p.bild; })) zeige('vorschau'); }
    function aktualisieren() {
      var n = anzahl(), fmt = formatWert(), gewaehlt = variante(auswahl()), A = verhaeltnis();
      wurzel.querySelectorAll('[data-nur-mit-schriftzug]').forEach(function (f) { f.hidden = !mitSchriftzug(); });
      if (kundenart) { kundenart.hidden = anzahl() < 50; firmaBox.hidden = !alsFirma(); }
      if (zub) {
        zubFarbe.hidden = !mitRahmen();
        var zo = zubSelect.options[zubSelect.selectedIndex];
        zubFarbe.querySelector('[data-farbpunkt]').style.setProperty('--farbe', zo.getAttribute('data-farbe') || 'transparent');
        var zz = wurzel.querySelector('[data-r-zubehoer-zeile]');
        zz.hidden = !mitRahmen();
        wurzel.querySelector('[data-r-zubehoer]').textContent = zubSelect.value + ' · +' + geld(+zub.getAttribute('data-zubehoer-preis'));
      }
      wurzel.querySelectorAll('[data-farbfeld]').forEach(function (f) {
        var o = menuepunkt('mg_farbe_' + f.getAttribute('data-farbfeld')), punkt = f.querySelector('[data-farbpunkt]');
        if (o && punkt) punkt.style.setProperty('--farbe', o.getAttribute('data-farbe') || 'transparent');
      });
      freitexte.forEach(function (box) {
        box.hidden = !freitextAktiv(box);
        box.querySelector('[data-freitext-zaehler]').textContent = box.querySelector('[data-freitext-feld]').value.length;
      });
      var gefuellt = 0;
      for (var i = 0; i < n; i++) if (plaetze[i].bild) gefuellt++;
      // Live-Vorschau: bis zu 12 Magnete im richtigen Format, bei vielen wiederholen sich die Fotos
      mini.textContent = '';
      mini.style.setProperty('--seite', A);
      var fotos = plaetze.slice(0, n).filter(function (p) { return p.bild; });
      var zeigen = Math.min(n, 12);
      mini.style.setProperty('--spalten', zeigen <= 4 ? 2 : (zeigen <= 9 ? 3 : 4));
      for (var k = 0; k < zeigen; k++) {
        var stein = document.createElement('i');
        var p = viele() ? fotos[k % (fotos.length || 1)] : plaetze[k];
        if (p && p.bild) {
          stein.className = 'voll';
          stein.style.backgroundImage = 'url("' + p.url + '")';
          var a = ausschnitt(p);
          stein.style.backgroundSize = (p.w / a.cw * 100).toFixed(2) + '% ' + (p.h / a.ch * 100).toFixed(2) + '%';
          var bx = (p.cx * p.w - a.cw / 2) / Math.max(1, p.w - a.cw), by = (p.cy * p.h - a.ch / 2) / Math.max(1, p.h - a.ch);
          stein.style.backgroundPosition = (bx * 100).toFixed(2) + '% ' + (by * 100).toFixed(2) + '%';
        }
        mini.appendChild(stein);
      }
      if (n > zeigen) { var mehr = document.createElement('b'); mehr.className = 'buehne__mehr'; mehr.textContent = t('mehr', { n: n - zeigen }); mini.appendChild(mehr); }

      preiseZeigen();
      var setText = n === 1 ? t('set_name_eins') : t('set_name_mehr', { n: n });
      aus.set.textContent = setText;
      aus.format.textContent = (fmt || '–') + (ausrichtung() ? ' · ' + t(ausrichtung()) : '');
      var teile = zusatzAngaben().map(function (e) { return e[0] + ': ' + e[1]; });
      aus.auswahlZeile.hidden = !teile.length;
      aus.auswahl.textContent = teile.join(' · ');
      var summe = gewaehlt ? gewaehlt.preis + (mitRahmen() ? +zub.getAttribute('data-zubehoer-preis') : 0) : 0;
      aus.summe.textContent = gewaehlt ? geld(summe) : '–';
      if (preisOben && gewaehlt) preisOben.textContent = geld(gewaehlt.preis);
      leisteSumme.textContent = gewaehlt ? geld(summe) : '–';
      leisteSet.textContent = setText + (fmt ? ' · ' + fmt : '');
      var fehlen = viele() ? (gefuellt ? 0 : 1) : n - gefuellt, textFehlt = freitextFehlt(), firmaFehlt = alsFirma() && !firmaFeld.value.trim();
      knopf.disabled = fehlen > 0 || !gewaehlt || textFehlt || firmaFehlt;
      leisteKnopf.textContent = fehlen > 0 ? t('kauf_fotos') : knopf.textContent;
      if (!gewaehlt) return melde(t('variante_fehlt'), 'fehler');
      if (textFehlt && fehlen === 0) return melde(t('text_fehlt'), '');
      if (firmaFehlt && fehlen === 0) return melde(t('firma_fehlt'), '');
      if (viele()) return melde(gefuellt ? t(gefuellt === 1 ? 'bereit_verteilt_eins' : 'bereit_verteilt', { k: gefuellt, n: n }) : t('foto_min'), gefuellt ? 'ok' : '');
      melde(fehlen === 0 ? t('bereit') : (fehlen === 1 ? t('fehlt_eins') : t('fehlen', { n: fehlen })), fehlen === 0 ? 'ok' : '');
    }
    function melde(text, art) { status.textContent = text; status.className = 'status' + (art ? ' status--' + art : ''); }

    // Zuschnitt in Druckqualität: längste Kante höchstens 1600 px, sonst volle Auflösung des Ausschnitts
    function druckbild(platz) {
      return new Promise(function (fertig) {
        var a = ausschnitt(platz), k = Math.min(1, DRUCK_PX / Math.max(a.cw, a.ch));
        var c = document.createElement('canvas');
        c.width = Math.round(a.cw * k); c.height = Math.round(a.ch * k);
        var ctx = c.getContext('2d');
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(platz.bild, platz.cx * platz.w - a.cw / 2, platz.cy * platz.h - a.ch / 2, a.cw, a.ch, 0, 0, c.width, c.height);
        c.toBlob(fertig, 'image/jpeg', 0.92);
      });
    }
    // [Name, Wert] für Optionen mit Aufpreis, eigenen Schriftzug und Farben – Zusammenfassung und Bestellung lesen dasselbe
    function zusatzAngaben() {
      var liste = [];
      wurzel.querySelectorAll('fieldset[data-option]').forEach(function (feld) {
        var w = wert('mg_opt_' + feld.getAttribute('data-option'));
        var box = feld.querySelector('[data-freitext]');
        var text = box && freitextAktiv(box) ? box.querySelector('[data-freitext-feld]').value.trim() : '';
        if (text) w = '„' + text + '“';
        liste.push([feld.getAttribute('data-name'), w]);
      });
      farbfelder().forEach(function (f) { var w = wert('mg_farbe_' + f.getAttribute('data-farbfeld')); if (w) liste.push([f.getAttribute('data-farbname'), w]); });
      if (alsFirma() && firmaFeld.value.trim()) liste.push([t('eig_firma'), firmaFeld.value.trim()]);
      return liste;
    }
    // Legt den leeren Rahmen (Zubehör) mit Farbe in den Warenkorb, bevor das Set abgeschickt wird
    function rahmenDazu() {
      if (!mitRahmen()) return Promise.resolve();
      var fd = new FormData(), o = zubSelect.options[zubSelect.selectedIndex];
      fd.append('id', zub.getAttribute('data-zubehoer-variante'));
      fd.append('quantity', '1');
      fd.append('properties[' + zubSelect.getAttribute('aria-label') + ']', o.getAttribute('data-bestellung') || o.value);
      fd.append('properties[' + t('eig_rahmen_fuer') + ']', zub.getAttribute('data-zubehoer-fuer'));
      return fetch(form.getAttribute('action').replace(/\/$/, '') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('Rahmen'); });
    }
    function eigenschaft(name, wert) {
      var f = document.createElement('input');
      f.type = 'hidden'; f.name = 'properties[' + name + ']'; f.value = wert;
      dateiAblage.appendChild(f);
    }

    knopf.addEventListener('click', function () {
      var n = anzahl(), v = variante(auswahl());
      var fotos = plaetze.slice(0, n).filter(function (p) { return p.bild; });
      if (!v) return melde(t('variante_fehlt'), 'fehler');
      if ((viele() ? !fotos.length : fotos.length < n) || freitextFehlt() || (alsFirma() && !firmaFeld.value.trim())) return aktualisieren();
      knopf.disabled = true;
      knopf.setAttribute('data-laedt', '');
      melde(t('upload_laeuft'), '');
      feldVariante.value = v.id;
      feldRecorte.value = fotos.map(function (p, k) {
        return (k + 1) + ': ' + p.name + ' ' + p.w + '×' + p.h + ', zoom ' + p.zoom.toFixed(2) + ', centro ' + p.cx.toFixed(3) + '/' + p.cy.toFixed(3);
      }).join(' | ');
      dateiAblage.textContent = '';
      if (ausrichtung()) eigenschaft(t('eig_ausrichtung'), t(ausrichtung()));
      if (viele()) eigenschaft(t('eig_aufteilung'), t(fotos.length === 1 ? 'fotos_fuer_eins' : 'fotos_fuer', { k: fotos.length, n: n }));
      // Der Schriftzug steht schon in der Variante; nur der eigene Text und die Farben kommen dazu
      freitexte.forEach(function (box) { if (freitextAktiv(box)) eigenschaft(t('eig_schriftzug'), box.querySelector('[data-freitext-feld]').value.trim()); });
      // Farben auf Portugiesisch mit deutschem Namen in Klammern, damit beide in der Bestellung lesen können, was gemeint ist
      farbfelder().forEach(function (f) { var o = menuepunkt('mg_farbe_' + f.getAttribute('data-farbfeld')); if (o) eigenschaft(f.getAttribute('data-farbname'), o.getAttribute('data-bestellung') || o.value); });
      if (alsFirma()) eigenschaft(t('eig_firma'), firmaFeld.value.trim());
      Promise.all(fotos.map(druckbild)).then(function (blobs) {
        blobs.forEach(function (blob, k) {
          var feld = document.createElement('input');
          feld.type = 'file';
          feld.name = 'properties[Foto ' + (k + 1) + ']';
          var dt = new DataTransfer();
          dt.items.add(new File([blob], 'magnet-' + (k + 1) + '.jpg', { type: 'image/jpeg' }));
          feld.files = dt.files;
          dateiAblage.appendChild(feld);
        });
        schnapp(mini);
        return rahmenDazu().then(function () { form.submit(); }, function () {
          knopf.disabled = false;
          knopf.removeAttribute('data-laedt');
          melde(t('zubehoer_fehler'), 'fehler');
        });
      }).catch(function () {
        knopf.disabled = false;
        knopf.removeAttribute('data-laedt');
        melde(t('kaputt'), 'fehler');
      });
    });

    // Galerie: Produktbilder und Live-Vorschau
    var bilder = wurzel.querySelectorAll('[data-bild]');
    var daumen = wurzel.querySelectorAll('[data-zeige]');
    var daumenVorschau = wurzel.querySelector('[data-zeige="vorschau"]');
    function zeige(ziel) {
      vorschauAn = ziel === 'vorschau';
      bilder.forEach(function (b) { b.hidden = b.getAttribute('data-bild') !== String(ziel); });
      mini.hidden = !vorschauAn;
      if (vorschauAn && daumenVorschau) daumenVorschau.hidden = false;
      daumen.forEach(function (d) { d.setAttribute('aria-pressed', d.getAttribute('data-zeige') === String(ziel) ? 'true' : 'false'); });
      if (vorschauAn) schnapp(mini);
    }
    daumen.forEach(function (d) { d.addEventListener('click', function () { zeige(d.getAttribute('data-zeige')); }); });
    // Über einen Farbpunkt gekommen (?farbe=Gold): Farbe im ersten Farbfeld vorwählen
    var farbeWunsch = (window.location.search.match(/[?&]farbe=([^&]+)/) || [])[1];
    var erstesFarbfeld = wurzel.querySelector('[data-farbfeld] select');
    if (farbeWunsch && erstesFarbfeld) {
      farbeWunsch = decodeURIComponent(farbeWunsch.replace(/\+/g, ' '));
      Array.prototype.forEach.call(erstesFarbfeld.options, function (o) { if (o.value === farbeWunsch) erstesFarbfeld.value = o.value; });
    }
    // Über eine Anlass-Kachel gekommen (?anlass=avos): deren Fotos zuerst zeigen
    var anlass = (window.location.search.match(/[?&]anlass=([a-z]+)/) || [])[1];
    if (anlass && wurzel.querySelector('[data-bild="' + anlass + '"]')) zeige(anlass);

    // Kaufleiste am Handy: erscheint, solange der Kaufbereich nicht im Bild ist
    var leiste = wurzel.querySelector('[data-kaufleiste]');
    var leisteSumme = wurzel.querySelector('[data-leiste-summe]');
    var leisteSet = wurzel.querySelector('[data-leiste-set]');
    var leisteKnopf = wurzel.querySelector('[data-leiste-knopf]');
    var kaufbox = wurzel.querySelector('[data-kaufbox]');
    leisteKnopf.addEventListener('click', function () {
      if (!knopf.disabled) return knopf.click();
      var ziel = liste.querySelector('.rahmen--leer') || (freitextFehlt() && wurzel.querySelector('[data-freitext]:not([hidden]) [data-freitext-feld]')) || wurzel.querySelector('#fotos');
      if (ziel) { ziel.scrollIntoView({ behavior: bewegungAus ? 'auto' : 'smooth', block: 'center' }); }
    });
    if ('IntersectionObserver' in window) {
      var kopfSichtbar = true, boxSichtbar = false;
      var setzeLeiste = function () {
        var an = !kopfSichtbar && !boxSichtbar;
        leiste.classList.toggle('an', an);
        leiste.setAttribute('aria-hidden', an ? 'false' : 'true');
        leisteKnopf.tabIndex = an ? 0 : -1;
      };
      new IntersectionObserver(function (e) { kopfSichtbar = e[0].isIntersecting; setzeLeiste(); }).observe(wurzel.querySelector('.produkt__preis'));
      new IntersectionObserver(function (e) { boxSichtbar = e[0].isIntersecting; setzeLeiste(); }).observe(kaufbox);
    }

    wurzel.addEventListener('change', function (e) {
      if (e.target.name === 'mg_anzahl' || e.target.name === 'mg_format' || e.target.name === 'mg_ausrichtung') { zeichnen(); if (e.target.name !== 'mg_anzahl') schnapp(mini); }
      else if (e.target.name === 'mg_kunde') { aktualisieren(); if (alsFirma()) firmaFeld.focus(); }
      else if (/^mg_(opt|farbe)_/.test(e.target.name)) {
        aktualisieren();
        var box = e.target.closest('[data-option]') && e.target.closest('[data-option]').querySelector('[data-freitext]');
        if (box && freitextAktiv(box)) box.querySelector('[data-freitext-feld]').focus();
      }
    });
    freitexte.forEach(function (box) { box.querySelector('[data-freitext-feld]').addEventListener('input', aktualisieren); });
    if (firmaFeld) firmaFeld.addEventListener('input', aktualisieren);
    if (zub) { zubAn.addEventListener('change', aktualisieren); zubSelect.addEventListener('change', aktualisieren); }
    window.addEventListener('resize', function () {
      liste.querySelectorAll('.rahmen[data-i]').forEach(function (r) { setzen(plaetze[+r.dataset.i], r); });
    });
    zeichnen();
  })();

  // ---------- 3. Live-Vorschau „Para festas“ / „Para negócios“ ----------
  (function () {
    var wurzel = document.querySelector('[data-gestalter="festa"], [data-gestalter="negocio"]');
    if (!wurzel) return;
    var magnet = wurzel.querySelector('[data-vorschau]');
    var istFesta = wurzel.getAttribute('data-gestalter') === 'festa';
    function ausgabe(name, wert) {
      var el = magnet.querySelector('[data-v-ausgabe="' + name + '"]');
      if (!el) return;
      var leer = !wert;
      el.textContent = leer ? (el.getAttribute('data-leer') || '') : wert;
      el.classList.toggle('leer-wert', leer && el.hasAttribute('data-leer'));
    }
    wurzel.querySelectorAll('[data-v-eingabe]').forEach(function (feld) {
      var ziel = feld.getAttribute('data-v-eingabe');
      var los = function () { ausgabe(ziel, feld.value.trim()); };
      feld.addEventListener('input', los);
      los();
    });
    var datum = wurzel.querySelector('[data-v-datum]');
    if (datum) {
      var datumLos = function () { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datum.value); ausgabe('data', m ? m[3] + ' · ' + m[2] + ' · ' + m[1] : ''); };
      datum.addEventListener('input', datumLos); datum.addEventListener('change', datumLos); datumLos();
    }
    var nurFrei = wurzel.querySelector('[data-nur-livre]');
    var freiFeld = wurzel.querySelector('#f-texto');
    function gewaehltFrei() { var r = wurzel.querySelector('[data-v-tipo-wahl]:checked'); return r && r.getAttribute('data-wert') === 'livre'; }
    if (freiFeld) freiFeld.addEventListener('input', function () { if (gewaehltFrei()) ausgabe('tipo', freiFeld.value.trim()); });
    wurzel.querySelectorAll('[data-v-tipo-wahl]').forEach(function (r) {
      r.addEventListener('change', function () {
        var frei = r.getAttribute('data-wert') === 'livre';
        if (nurFrei) nurFrei.hidden = !frei;
        ausgabe('tipo', frei ? (freiFeld ? freiFeld.value.trim() : '') : r.getAttribute('data-text'));
        if (frei && freiFeld) freiFeld.focus();
      });
    });
    var datei = wurzel.querySelector('[data-v-foto]');
    var platz = magnet.querySelector('[data-v-foto-platz]');
    var weg = wurzel.querySelector('[data-v-foto-weg]');
    var zeichen = magnet.querySelector('[data-v-zeichen]');
    var url = null;
    function fotoSetzen(neu) {
      if (url) URL.revokeObjectURL(url);
      url = neu;
      platz.hidden = !url;
      platz.style.backgroundImage = url ? 'url("' + url + '")' : '';
      if (weg) weg.hidden = !url;
      if (istFesta) magnet.classList.toggle('mv--mit-foto', !!url);
      if (zeichen) zeichen.style.display = url ? 'none' : '';
    }
    if (datei && platz) {
      datei.addEventListener('change', function () {
        var f = datei.files && datei.files[0];
        if (!f || !/^image\//.test(f.type)) { datei.value = ''; return; }
        fotoSetzen(URL.createObjectURL(f));
        datei.value = '';   // die Datei wird nie mit dem Formular gesendet (nur Vorschau)
      });
    }
    if (weg) weg.addEventListener('click', function () { fotoSetzen(null); if (datei) datei.focus(); });
    wurzel.querySelectorAll('[data-v-thema]').forEach(function (r) {
      r.addEventListener('change', function () { magnet.setAttribute('data-thema', r.getAttribute('data-thema')); schnapp(magnet); });
    });
    var form = wurzel.querySelector('form');
    var senden = wurzel.querySelector('[data-senden]');
    if (form && senden) {
      form.addEventListener('submit', function () {
        senden.disabled = true;   // Doppelklick sendet nicht zweimal
        senden.textContent = t('senden_laeuft');
      });
    }
  })();

  // ---------- 4. Betriebs-Magnet zum Ausprobieren (Startseite) ----------
  // Beschriftet sich live mit dem, was man eintippt. Nichts wird gesendet oder gespeichert.
  // Die Standardtexte stehen am Feld (data-std-*), je Sprache aus den Sprachdateien.
  (function () {
    var felder = document.querySelector('[data-beweis]');
    var mag = document.querySelector('[data-bmag]');
    if (!felder || !mag) return;
    var ein = { name: document.getElementById('b-name'), was: document.getElementById('b-was'), tel: document.getElementById('b-tel') };
    var aus = { name: mag.querySelector('.bmag__name'), was: mag.querySelector('.bmag__was'), tel: mag.querySelector('.bmag__tel') };
    var std = { name: felder.getAttribute('data-std-name'), was: felder.getAttribute('data-std-was'), tel: felder.getAttribute('data-std-tel') };
    ein.name.value = std.name;
    ein.was.value = std.was;
    function zeige() {
      ['name', 'was'].forEach(function (k) { aus[k].textContent = ein[k].value.trim() || std[k]; });
      var tel = ein.tel.value.trim();
      aus.tel.textContent = tel || std.tel;
      aus.tel.classList.toggle('leer', !tel);
    }
    Object.keys(ein).forEach(function (k) {
      ein[k].addEventListener('input', function () {
        zeige();
        if (bewegungAus) return;
        mag.classList.remove('wackelt'); void mag.offsetWidth; mag.classList.add('wackelt');
      });
    });
    zeige();
  })();
})();
